module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns_5.96ff7e7d.svg";